import numeral from 'numeral';

const abbreviate = (value, locale = numeral.locale) => {
  numeral.locale(locale);
  return numeral(value)
    .format('0.0a')
    .locale();
};

const bytes = (value, locale = numeral.locale) => {
  numeral.locale(locale);
  return numeral(value).format('0 b');
};

const exposedNumeral = (value, format, locale = numeral.locale) => {
  numeral.locale(locale);
  return numeral(value).format(format);
};

const exponential = (value, locale = numeral.locale()) => {
  numeral.locale(locale);
  return numeral(value).format('0.[00]e+0');
};

const ordinal = (value, locale = numeral.locale()) => {
  numeral.locale(locale);
  return numeral(value).format('Oo');
};

const percentage = (value, locale = numeral.locale()) => {
  numeral.locale(locale);
  return numeral(value / 100).format('0.[00]%');
};

const separator = (value, locale = numeral.locale()) => {
  numeral.locale(locale);
  return numeral(value).format('0,0');
};

const currency = (value, locale = numeral.locale()) => {
  numeral.locale(locale);
  return numeral(value).format('0,0[.]00[00] $');
};

export { abbreviate, bytes, exponential, exposedNumeral, ordinal, percentage, separator, currency };
